<template>
    <v-container fluid>
        <v-card class="pa-6" color="grey-lighten-4" rounded="sm" elevation="2">
            <h3 class="text-h6 mb-6 font-weight-medium">{{ texts.title }}</h3>
            <div id="chart_div" style="width: 100%; height: 500px"></div>
        </v-card>
    </v-container>
</template>

<script>
import { GOOGLE_MAPS_API_KEY } from '@/config/google-maps-config';
export default {
    name: 'VisitsMap',
    props: {
        visitsMapData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: null
        };
    },
    computed: {
        texts() {
            return {
                title: this.$t('Statistic.map.title'),
                countryLabel: this.$t('Statistic.map.country'),
                visitsLabel: this.$t('Statistic.map.visits')
            };
        }
    },
    mounted() {
        if (!window.google || !window.google.charts) {
            const script = document.createElement('script');
            script.src = 'https://www.gstatic.com/charts/loader.js';
            script.onload = this.loadChart;
            document.head.appendChild(script);
        } else {
            this.loadChart();
        }
    },
    methods: {
        loadChart() {
            window.google.charts.load('current', {
                packages: ['geochart'],
                mapsApiKey: GOOGLE_MAPS_API_KEY
            });
            window.google.charts.setOnLoadCallback(() => {
                this.drawMap();
            });
        },
        drawMap() {
            if (!this.visitsMapData || Object.keys(this.visitsMapData).length === 0) {
                console.warn('No data to display the card.');
                return;
            }

            const chartDiv = document.getElementById('chart_div');
            if (!chartDiv) {
                console.error('Élete #Chart_div not found.');
                return;
            }

            const dataArray = [[this.texts.countryLabel, this.texts.visitsLabel]];
            for (const [country, visits] of Object.entries(this.visitsMapData)) {
                dataArray.push([country, visits]);
            }
            const data = window.google.visualization.arrayToDataTable(dataArray);

            const options = {
                displayMode: 'regions',
                colorAxis: { colors: ['#E31445', '#141111'] },
                backgroundColor: '#81d4fa',
                datalessRegionColor: 'white',
                defaultColor: '#f5f5f5',
                zoomLevel: 1
            };

            if (!this.chart) {
                this.chart = new window.google.visualization.GeoChart(chartDiv);
            }
            this.chart.draw(data, options);
        }
    },
    watch: {
        visitsMapData: {
            deep: true,
            handler() {
                if (window.google && window.google.visualization) {
                    this.drawMap();
                }
            }
        }
    }
};
</script>
